import { httpClient } from './httpClient';

export interface AuditLog {
  id: number;
  action: string;
  old_data: Record<string, any> | null;
  new_data: Record<string, any> | null;
  changed_at: string;
  changed_by: number | string;
  entity_id: number;
  entity_type: 'ticket' | 'comment' | 'customer' | 'attachment';
  user_info?: {
    id: number;
    name: string;
    email: string;
    role: string;
  } | null;
  change_summary?: string;
}

export interface GetAuditLogsOptions {
  entityType?: string;
  entityId?: number;
  startDate?: string;
  endDate?: string;
  limit?: number;
  page?: number;
}

export interface GetAuditLogsResponse {
  logs: AuditLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const auditService = {
  async getAuditLogs(options: GetAuditLogsOptions): Promise<GetAuditLogsResponse> {
    const queryParams = new URLSearchParams();
    
    // Add non-empty parameters to the query string
    if (options.entityType) {
      // Ensure first letter is capitalized to match backend expectation
      const entityType = options.entityType.charAt(0).toUpperCase() + options.entityType.slice(1).toLowerCase();
      queryParams.set('entityType', entityType);
    }
    if (options.entityId) queryParams.set('entityId', options.entityId.toString());
    if (options.startDate) queryParams.set('startDate', options.startDate);
    if (options.endDate) queryParams.set('endDate', options.endDate);
    if (options.limit) queryParams.set('limit', options.limit.toString());
    if (options.page) queryParams.set('page', options.page.toString());

    const url = `/api/audit/logs${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return httpClient.get<GetAuditLogsResponse>(url);
  }
};
